import type { BrandingConfig, ThemeAndColors } from "../types";

/** Regulation detail jump links — fixed blue, not tied to theme primaryColor. */
export const REGULATION_DETAIL_LINK_COLOR = "#295EF1";

export const DEFAULT_THEME_AND_COLORS: ThemeAndColors = {
  primaryColor: "#2563EB",
  // primaryColor: "#E8772A",
  secondaryColor: "#2D2D2D",
  primaryFontColor: "#FFFFFF",
  secondaryFontColor: "#666666",
  headerBackgroundColor: "#295EF1",
};

export const DEFAULT_BRANDING_CONFIG: BrandingConfig = {
  brandIdentity: {
    favicon: "/favicon.svg",
    headerLogo: {
      dark: "/freya.png",
      light: "/freya.png",
    },
    title: "Freya Fusion",
  },
  loginScreen: {
    logo: "/freya.png",
    supportEmail: "support@freyafusion.com",
    termsAndConditions: {
      url: "/TermsOfUser.pdf",
      hidden: false,
    },
    privacyPolicy: {
      url: "/PrivacyPolicy.pdf",
      hidden: false,
    },
  },
  documentBranding: {
    logo: "/freya.png",
    footerText: "",
    watermark: null,
  },
  themeAndColors: DEFAULT_THEME_AND_COLORS,
  extra: {
    pageTitle: "Freya Fusion",
  },
};

export const BRANDING_CACHE_TTL_MS = 10 * 60 * 1000;
